export default __webpack_public_path__ + "static/media/45.d413eaf0.png";